import SpecificGames from './specific_games';

export default SpecificGames